"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_use_1 = require("react-use");
const react_2 = require("@osmosys/react");
const graphql_1 = require("../../graphql");
const AppIsReady_1 = require("./AppIsReady");
const OsmosysIsOutOfDateToast_1 = require("./OsmosysIsOutOfDateToast");
const AppLoaderIndicator_1 = require("./AppLoaderIndicator");
const react_hanger_1 = require("react-hanger");
const logger_1 = require("../logger");
const useLogRocket_1 = require("../../hooks/useLogRocket");
const hooks_1 = require("../../hooks");
const react_if_1 = require("react-if");
const REFETCH_INTERVAL = 20 * 1000;
const IDLE_TIMEOUT = 25 * 1000;
exports.LOAD_DELAY = 1 * 1000;
exports.AppLoader = () => {
    hooks_1.useSentry({});
    useLogRocket_1.useLogRocket();
    const userIsNowIdle = react_use_1.useIdle(IDLE_TIMEOUT);
    const userIsNowActive = !userIsNowIdle;
    const userWasIdle = react_hanger_1.usePrevious(userIsNowIdle);
    const userWasActive = !userWasIdle;
    const [loaded, setLoaded] = react_use_1.useToggle(false);
    const { loadApp, adminRole, appHasLoaded } = hooks_1.useOsmosysContext();
    const { updateOsmosysContext } = hooks_1.useOsmosysUpdate();
    const [fireLoad, result] = react_hooks_1.useLazyQuery(graphql_1.loadApp, {
        notifyOnNetworkStatusChange: false,
    });
    const { data, refetch, error, loading, networkStatus } = result;
    react_use_1.useMount(() => {
        fireLoad();
    });
    const refetchAndLog = () => {
        refetch();
    };
    // Idle status changed. Refetch.
    react_1.useEffect(() => {
        if (userIsNowActive && userWasIdle) {
            // refetch();
            refetchAndLog();
        }
        else if (userIsNowIdle && userWasActive) {
            logger_1.websiteLogger.info('User is now idle');
        }
    }, [userIsNowIdle, userWasIdle, refetch]);
    // Refetch app every REFETCH_INTERVAL
    react_use_1.useInterval(() => {
        if (userIsNowActive && loadApp) {
            // refetch();
            refetchAndLog();
        }
    }, REFETCH_INTERVAL);
    react_1.useEffect(() => {
        if (data && !loaded) {
            setLoaded(true);
        }
    }, [!!data]);
    // New data. Save to context.
    react_1.useEffect(() => {
        var _a, _b, _c;
        if (loaded) {
            const updatedData = {
                adminRole: adminRole || false,
                adminRoles: [],
                loadApp: {
                    error,
                    loading,
                    refetch,
                },
            };
            updatedData.adminRoles = updatedData.adminRoles || [];
            if (data) {
                const settings = data.appSettings;
                const user = data.currentUser;
                updatedData.appSettings = settings;
                updatedData.currentUser = user;
                if ((_a = user) === null || _a === void 0 ? void 0 : _a.isAppAdmin) {
                    updatedData.adminRoles.push('app');
                }
                if ((_c = (_b = user) === null || _b === void 0 ? void 0 : _b.currentWorkspaceMembership) === null || _c === void 0 ? void 0 : _c.isWorkspaceAdmin) {
                    updatedData.adminRoles.push('workspace');
                }
                updatedData.adminRole = updatedData.adminRoles[0] || false;
            }
            updateOsmosysContext(Object.assign(Object.assign({}, updatedData), { isLoggedIn: !!updatedData.currentUser }));
        }
    }, [loaded, data, loading, error, networkStatus]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_if_1.When, { condition: loaded }, () => react_1.default.createElement(AppIsReady_1.AppIsReady, null)),
        react_1.default.createElement(react_if_1.When, { condition: !appHasLoaded }, () => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(AppLoaderIndicator_1.AppLoaderIndicator, null),
            react_1.default.createElement(react_2.OsmosysErrorAlert, { apolloError: error, resource: "AppSettings", action: "read", retrying: loading, errorPrefix: "Failed to connect to Osmosys", retry: () => result.refetch() })))),
        react_1.default.createElement(OsmosysIsOutOfDateToast_1.OsmosysIsOutOfDateToast, null)));
};
//# sourceMappingURL=index.js.map